import { Component, OnInit, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { FormGroup } from '@angular/forms';
import { Validators } from '../../../../shared/validators';
import { ChangePasswordService } from 'src/app/shared/components/change-password/change-password.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TwoFactorAuthOtpService } from 'src/app/shared/services/two-factor-auth/two.factor.auth.service';
import { CustomValidators } from 'src/app/shared/custom-validators';
import { timer } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

@Component({
  selector: 'app-change-lastpassword',
  templateUrl: './change-lastpassword.component.html',
  styleUrls: ['./change-lastpassword.component.scss'],
})
export class ChangeLastpasswordComponent implements OnInit {
  oldPasswordHide: boolean = true;
  newPasswordHide: boolean = true;
  confirmNewPasswordHide: boolean = true;
  formValidator!: FormValidatorService;
  changePasswordForm!: FormGroup;
  sendCodeClicked: boolean = false;
  timer: any;
  sendFailed = null;

  constructor(
    private translate: TranslateService,
    public dialogRef: MatDialogRef<ChangeLastpasswordComponent>,
    private changePassword: ChangePasswordService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private twoFactorAuthOtpService: TwoFactorAuthOtpService
  ) {}

  async ngOnInit() {
    await this.twoFactorAuthOtpService.sendOtp('changePassword');
    this.formValidator = new FormValidatorService();
    this.changePasswordForm = this.formValidator.createForm([
      {
        fieldName: 'old_password',
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
          {
            validatorFn: CustomValidators.customPattern(/^(.{6,}$|$)/g),
            message: '',
          },
          {
            validatorFn: CustomValidators.oldPasswordNotEmpty('old_password'),
            message: '',
          },
        ],
      },
      {
        fieldName: 'new_password',
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
          {
            validatorFn: CustomValidators.customPattern(/^(.{8,}$|$)/g),
            message: '',
          },
          {
            validatorFn: CustomValidators.differentPassword('old_password'),
            message: '',
          },
          {
            validatorFn: CustomValidators.complexPassword('s'),
            message: '',
          },
        ],
      },
      {
        fieldName: 'confirm_new_password',
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
          {
            validatorFn: CustomValidators.customPattern(/^(.{8,}$|$)/g),
            message: '',
          },
          {
            validatorFn: CustomValidators.confirmPasswordWith('new_password'),
            message: '',
          },
        ],
      },
      {
        fieldName: 'otp',
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
          {
            validatorFn: CustomValidators.customPattern(/^(.{6,}$|$)/g),
            message: '',
          },
        ],
      },
    ]);
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    });
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.formValidator.validationMessages = {
        old_password: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Old password',
            fieldAr: 'كلمة السر القديمة',
          }),
          customPattern: this.translate.instant('FormValidation.MinLength', {
            field: 'Old password',
            fieldAr: 'كلمة السر القديمة',
            value: 6,
          }),
          oldPasswordNotEmpty: this.translate.instant('FormValidation.Empty', {
            field: 'Old password',
            fieldAr: 'كلمة السر القديمة',
          }),
        },
        new_password: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'New password',
            fieldAr: 'كلمة السر الجديدة',
          }),
          customPattern: this.translate.instant('FormValidation.MinLength', {
            field: 'New password',
            fieldAr: 'كلمة السر الجديدة',
            value: 8,
          }),
          differentPassword: this.translate.instant('FormValidation.NotMatch', {
            field: 'New password',
            fieldAr: 'كلمة السر الجديدة',
            theOtherField: 'Old password',
            theOtherFieldAr: 'كلمة السر القديمة',
          }),
          complexPassword: this.translate.instant(
            'FormValidation.complexPassword',
            {
              field: 'New password',
              fieldAr: 'كلمة السر الجديدة',
            }
          ),
        },
        confirm_new_password: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Confirm new password',
            fieldAr: 'تأكيد كلمة السر الجديدة',
          }),
          minLength: this.translate.instant('FormValidation.MinLength', {
            field: 'Confirm new password',
            fieldAr: 'تأكيد كلمة السر الجديدة',
            value: 8,
          }),
          confirmPasswordWith: this.translate.instant(
            'FormValidation.Different',
            {
              field: 'Confirm new password',
              fieldAr: 'تأكيد كلمة السر الجديدة',
              theOtherField: 'New password',
              theOtherFieldAr: 'كلمة السر الجديدة',
            }
          ),
        },
      };
    });
  }

  async submit() {
    this.changePassword.setParams(this.changePasswordForm.value);
    try {
      await this.changePassword.make();
      this.changePasswordForm.reset();
      this.router.navigate(['/seller/dashboard']);
    } catch (err: any) {
      this.twoFactorAuthOtpService.handleErrors(err);
      await this.twoFactorAuthOtpService.sendOtp('changePassword');
      this.formValidator.addError(
        'old_password',
        'wrong',
        this.translate.instant('FORMS.VALIDATION.IVALID', {
          field: 'Password',
        })
      );
      this.changePasswordForm.controls['old_password'].setErrors({
        wrong: 'invalid',
      });
      this.formValidator.ShowErrors();
    }
  }

  async reSend() {
    try {
      this.sendCodeClicked = true;
      await this.twoFactorAuthOtpService.sendOtp('changePassword');
      let count = 30;
      this.timer = timer(0, 1000).pipe(
        take(count),
        map(() => --count),
        tap((res) => {
          if (res == 0) this.sendCodeClicked = false;
        })
      );
    } catch (err) {
      console.log(err);
      this.sendFailed = err.message;
    }
  }
}
